import { AbstractControl, ValidationErrors } from '@angular/forms';

export class FormValidators {

	static phoneNumber(control: AbstractControl): ValidationErrors | null {
		const value = control.value;
		if (!value) return null;

		const phoneRegex = /^[6-9]\d{9}$/;
		return phoneRegex.test(value) ? null : { invalidPhone: true };
	}

	static alphabetsOnly(control: AbstractControl): ValidationErrors | null {
		const value = control.value;
		if (!value) return null;

		const alphaRegex = /^[A-Za-z ]+$/;
		return alphaRegex.test(value) ? null : { alphabetsOnly: true };
	}

	static pinCode(control: AbstractControl): ValidationErrors | null {
		const value = control.value;
		if (!value) return null;

		const pinRegex = /^\d{6}$/;
		return pinRegex.test(value) ? null : { invalidPincode: true };
	}
}
